import React from 'react';
import BillLines from '../BillLines';
import { CashIcon, UpiIcon } from '../../common/icons';
import { formatMoney, paidTotal, pendingAmount } from '../../../utils/money';

const METHODS = [
  { id: 'cash', label: 'Cash', sub: 'Count the cash and enter the amount', icon: CashIcon },
  { id: 'upi', label: 'UPI', sub: 'Check the UPI credit, then confirm', icon: UpiIcon },
];

/** Step 4 — collect the full amount by cash or UPI. Form state lives in the wizard (the cart button submits it). */
export default function PaymentStep({ bill, pay, onPay }) {
  const due = pendingAmount(bill);
  const entered = Number(pay.amount) || 0;
  const short = Math.max(0, Math.round((due - entered) * 100) / 100);

  return (
    <div className="dp-step-body">
      <div className="dp-step-head">
        <h2>Payment</h2>
        <p className="dp-help">
          How is <strong>{bill.customer?.name || 'the guest'}</strong> paying?
        </p>
      </div>

      <div className="dp-choice-grid dp-choice-grid--two">
        {METHODS.map(({ id, label, sub, icon: Icon }) => (
          <button key={id} type="button" className={`dp-choice${pay.method === id ? ' is-on' : ''}`} onClick={() => onPay({ ...pay, method: id, amount: pay.amount || String(due) })}>
            <Icon size={24} />
            <strong>{label}</strong>
            <small>{sub}</small>
          </button>
        ))}
      </div>

      {pay.method ? (
        <div className="dp-pay-form">
          <div className="dp-pay-totals">
            <div>
              <span>Total</span>
              <strong>{formatMoney(bill.grand_total)}</strong>
            </div>
            <div>
              <span>Already paid</span>
              <strong>{formatMoney(paidTotal(bill))}</strong>
            </div>
            <div className={short > 0 ? 'is-due' : 'is-clear'}>
              <span>Still to pay</span>
              <strong>{formatMoney(short)}</strong>
            </div>
          </div>
          <label className="dp-field">
            <span>{pay.method === 'cash' ? 'Cash received' : 'Amount received on UPI'}</span>
            <input
              className="dp-input dp-input--lg"
              inputMode="decimal"
              value={pay.amount}
              onChange={(e) => onPay({ ...pay, amount: e.target.value.replace(/[^\d.]/g, '') })}
            />
          </label>
          {pay.method === 'upi' ? (
            <label className="dp-field">
              <span>UPI reference (optional)</span>
              <input className="dp-input" value={pay.upiRef} onChange={(e) => onPay({ ...pay, upiRef: e.target.value })} placeholder="UTR / transaction ID" />
            </label>
          ) : null}
          {short > 0 ? <p className="dp-cart-warn">Take the full amount: {formatMoney(due)}.</p> : null}
        </div>
      ) : null}

      <BillLines bill={bill} />
    </div>
  );
}
